import { render, staticRenderFns } from "./PToolbarImage.vue?vue&type=template&id=000be224"
import script from "./PToolbarImage.vue?vue&type=script&lang=js"
export * from "./PToolbarImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports